<div class="clearfix">
    <div class="container">
        <div class="clsTermConditions">
            <h1> Communication & Operations Mobile Engagement Tool Privacy Policy </h1>

            <p>
                Individuals who visit the WV.gov website are important to us. Because visitors to our website are
                important, we do not
                capture personal information about them without their permission. We endeavor to collect only the
                minimum amount of
                information needed to meet the purposes for which the website was created.
            </p>

            <div class="clearfix mb-3">
                <h2> Use of This Policy </h2>

                <p>
                    Various websites are linked through the WV.gov website. State and local government agencies may have
                    their own privacy
                    statements posted on their sites, which take precedence over this policy. The WV.gov Privacy
                    Statement does not apply to
                    non-West Virginia State Government websites that may be linked from WV.gov. Visitors should read the
                    privacy policies of
                    individual sites and be cautious about providing personally identifiable information without a clear
                    understanding of
                    how the information will be used.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> Privacy Statement </h2>

                <h3> Public Disclosure </h3>

                <p>
                    All information collected on the WV.gov website will be treated the same as any written
                    communication and is subject to
                    the confidentiality and public disclosure provisions of <a
                        href="https://code.wvlegislature.gov/29B/" target="_blank" rel="noopener">West Virginia Code Chapter
                        29B</a>.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> Visitors to the WV.gov Website </h2>

                <p>
                    We may collect some or all of the following information about visitors who view or download
                    information from our
                    website:
                </p>

                <div class="clearfix">
                    <table class="table" aria-label="User access table">
                        <thead>
                            <tr>
                                <th class="clsWidth-140"> Information </th>
                                <th> Definition </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td class="clsWidth-140"> Date </td>
                                <td> Date the visit occurred. </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> Time </td>
                                <td> Time the visit occurred. </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> Client IP </td>
                                <td>
                                    ​Unique Internet Protocol (IP) address of the website visitor. The IP address
                                    recorded is normally that of the visitor's
                                    Internet service provider, e.g., aol.com if the visitor connects from an America
                                    Online account.
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> Server IP </td>
                                <td>
                                    Unique Internet Protocol (IP) address of the State of West Virginia web server
                                    accessed.
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> HTTP Status </td>
                                <td>
                                    Hyper Text Transfer Protocol (HTTP) error code. E.g., "404 Requested Page Not
                                    Found."
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> HTTP Request URL </td>
                                <td>
                                    Identifies the web page or file requested by the website visitor.
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> Bytes Sent </td>
                                <td>
                                    Amount of data sent from the web server to website visitor during that connection.
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> Bytes Received </td>
                                <td>
                                    Amount of data sent from website visitor to the web server.
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> User Agent </td>
                                <td>
                                    Type of web browser or other client software that made request to the web server.
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> Referrer </td>
                                <td>
                                    Uniform Resource Locator (URL) that referred to the requested file.
                                </td>
                            </tr>

                            <tr>
                                <td class="clsWidth-140"> Protocol Version </td>
                                <td>
                                    Version of HTTP used by the visitor's web browser software.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p>
                    The information we collect is used to improve the content of our web services and help us understand
                    how people are
                    using our services. We analyze our website logs to continually improve the value of the materials
                    available on our site.
                    The information in our website logs is not personally identifiable, and we make no attempt to link
                    it with the
                    individuals that browse our website. Some of this statistical information, such as a running count
                    of the number of
                    visitors, may be displayed on the website or shared with other state governments to aid in the
                    provision of better
                    service to the public.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> Personally Identifiable Information </h2>

                <p>
                    "Personally identifiable information" is information about a person that is readily identifiable to
                    that specific
                    individual. It includes, for example, an individual's name, street address, e-mail address, or phone
                    number.
                </p>

                <p>
                    Personally identifiable information will not be collected unless you voluntarily send an e-mail
                    message, fill out and
                    send an online form, or fill out personal information and send in a survey. Your choice not to
                    participate in these
                    activities will not impair your ability to access certain information or obtain a service from state
                    government (though
                    you may not be able to complete the transaction or service online). Unless specifically protected
                    under state law, any
                    information provided may be inspected by the public or disclosed in a legal proceeding.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> E-mail Messages </h2>

                <p class="mb-1">
                    E-mail messages, sent to any West Virginia State Government address, will be treated the same as any
                    other written
                    communication. They may be subject to public inspection or legal disclosure and may be saved for a
                    period of time before
                    they are destroyed. E-mail or other information requests sent to the state website may be maintained
                    in order to respond
                    to the request, forward that request to the appropriate agency, or to provide the web designer with
                    valuable customer
                    feedback to assist in improving the site. E-mail addresses obtained as a result of a request to the
                    state site will not
                    be sold or given to private companies for marketing purposes.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> Electronic Forms </h2>

                <p class="mb-1">
                    Any other information provided by a visitor at the request of an agency of West Virginia State
                    Government, such as the
                    completion and electronic filing of a form, will be considered to be voluntarily provided by the
                    visitor and will be
                    treated in the same manner as information provided in written form or in person during a visit to
                    the agency.
                    Information provided may be subject to public inspection and legal disclosure and may be saved for a
                    period of time
                    before it is destroyed. It may be shared with another state agency for appropriate action.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> Surveys </h2>

                <p class="mb-1">
                    Surveys will be used for the purpose stated. If personally identifiable information is collected it
                    may be subject to
                    public inspection and legal disclosure and may be saved for a period of time before it is destroyed.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> West Virginia Interactive Subscribers </h2>

                <p>
                    The Information Resource of West Virginia collects, retains and utilizes personal information about
                    its customers only
                    when they volunteer to subscribe to West Virginia Interactive. The information is used to administer
                    subscriber accounts
                    and to provide products, services and other opportunities requested by West Virginia Interactive
                    subscribers. Records
                    containing personal information about West Virginia Interactive subscribers are confidential and may
                    only be released
                    with the express written permission of the subscriber pursuant to the provisions of <a
                        href="https://code.wvlegislature.gov/29B/" target="_blank" rel="noopener">West Virginia Code Chapter
                        29B</a>.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> Cookies </h2>

                <p>
                    In order to better serve you, the user, we use cookies for certain types of online transactions.
                    Cookies are small text
                    files that a web server may ask your web browser to store, and to send back to the web server when
                    needed. Cookies may
                    be used to store a transaction identifier or other information a user may provide. We use cookies in
                    the following ways:
                </p>

                <ul class="clearfix">
                    <li>
                        <span class="font-weight-bold">Complex Transactions:</span> Cookies are used to store and
                        retrieve unique transaction identifiers or
                        other server-generated or user-provided information in complex, multi-page web applications.
                        This allows us to
                        distinguish between different users, and to use information provided at one stage of an
                        application at a later time (for
                        instance, items placed in a 'shopping cart' might need to be displayed on a later 'check-out'
                        screen). When we use
                        cookies in this way, the cookie is stored on your web browser only temporarily; the cookie is
                        destroyed at the end of
                        the transaction or at the end of the browser session.
                    </li>

                    <li>
                        <span class="font-weight-bold">Customized Services:</span> Cookies may also be used to
                        automatically identify a particular user to the system, in
                        order to provide a customized service, such as a personalized web page. In this case, a cookie
                        containing a unique user
                        identifier will be permanently stored on your web browser. We do not store sensitive information
                        in such cookies; only a
                        unique user identifier or generic preference values are stored. Personal information you give us
                        for processing a
                        transaction or using one of our personalization features, may be stored on our secure web
                        server.
                    </li>
                </ul>

                <p>
                    We do not use cookies in order to track your visit to our website. The "help" portion of the toolbar
                    on most browsers
                    will tell you how to prevent your browser from accepting new cookies or how to disable cookies
                    altogether. However,
                    cookies allow you to take full advantage of many of West Virginia's eGovernment services, and we
                    recommend that you set
                    your web browser to accept cookies.
                </p>

                <p>
                    If you have further questions about cookies, the Computer Incident Advisory Capacity unit that
                    monitors computer
                    problems for the U.S. Department of Energy issued a study on March 12, 1998 of the risks of cookies
                    to users, titled
                    Information Bulletin I-034: Internet Cookies. You can refuse the cookies or delete the cookie file
                    from your computer by
                    using any of the widely available methods.
                </p>
            </div>

            <div class="clearfix mb-3">
                <h2> Children's Online Privacy Protection Act </h2>

                <p>
                    Children under the age of 13 are not eligible to use services that require submission of personal
                    information and should
                    not submit any personal information to us. This includes submitting personal information to the
                    website as part of a
                    user profile or personalization profile. If you are a child under the age of 13, you can use these
                    services only if used
                    together with your parents or guardians. Seek guidance from your parents or guardians if you are
                    under the age of 13.
                </p>

                <p>
                    If we decide to begin collecting personal information from children under the age of 13, we will
                    notify parents that it
                    is being requested, disclose the reasons for collecting it, and disclose our intended use of it. We
                    will seek verifiable
                    parental consent before collecting any personally identifiable information. If we do collect such
                    information, parents
                    may request information on the type of data being collected, view their child's information, and, if
                    they choose,
                    prohibit us from making further use of their child's information. We will not provide personal
                    information about
                    children to third parties.
                </p>
            </div>

            <div class="clearfix">
                <h2> Contact Information </h2>

                <p class="mb-3">
                    To offer comments or ask questions about West Virginia privacy policies please contact:
                </p>

                <address>
                    <p class="no-mar"> 1124 Smith Street, Suite 4700 </p>
                    <p class="no-mar"> Charleston, WV 25301 </p>
                    <p class="no-mar"> (304) 766-2646 </p>
                    <p class="no-mar"> <a
                            href="https://wv.accessgov.com/privacy/Forms/Page/privacy-office-contact/contact-privacy"
                            rel="noopener" target="_blank"> Email Us </a> </p>
                </address>
            </div>
        </div>
    </div>
</div>